export default __webpack_public_path__ + "static/media/bin_red.39f89fac.svg";